
<template>
<div id="glossary" >
  <v-app style="background: #003333;">
    <div class="breadcrumbs">
        <button class="breadcrumb-home breadcrumb-btn" style="box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.3);" @click="$store.state.showTimeline = true; $store.state.showGlossary = false" aria-label="Go to main timeline">
            <img v-bind:src="require(`@/assets/ui/icon_breadcrumb_home.png`)" id="home-icon">
            <p>Timeline Home</p>
        </button>
        <button class="breadcrumb-current breadcrumb-btn">
            <p style="color: black"><span>Glossary</span></p>
        </button>
    </div>

    <div class="glossary-title">
        <h4><img v-bind:src="require(`@/assets/ui/icon_glossary-book.png`)" id="book-img"> Glossary </h4>
    </div>

    <table class="desktop-table">
      <tr v-for="i in json.length/2" :key="i">
        <td><p class="glossary-left-row"><span style="color:#cc9933">{{ termsLeft[i-1] }}:</span> {{ descriptionsLeft[i-1] }}</p></td>
        <td><p class="glossary-right-row"><span style="color:#cc9933">{{ termsRight[i-1] }}:</span> {{ descriptionsRight[i-1] }}</p></td>
      </tr>
    </table>
    <table class="mobile-table">
      <tr v-for="i in json.length" :key="i">
        <p ><span style="color:#cc9933">{{ terms[i-1] }}:</span> {{ descriptions[i-1] }}</p>
      </tr>
    </table>
  </v-app>
</div>
</template>

<script>
  import data from '@/content/glossaryTerms.js'
  export default {
    name: 'PrimarySource',

    computed: {
    },

    methods: {
      getTerms(){
        this.json.sort();
        let len = this.json.length;

        for(let i = 0; i < len/2; i++)
        {
          this.termsLeft.push(this.json[i].term);
          this.descriptionsLeft.push(this.json[i].description);
        }
        for(let i = len/2; i < len; i++)
        {
          this.termsRight.push(this.json[i].term);
          this.descriptionsRight.push(this.json[i].description);
        }
        for(let i = 0; i < len; i++)
        {
          this.terms.push(this.json[i].term);
          this.descriptions.push(this.json[i].description);
        }
        console.log(this.termsLeft, this.termsRight)
      },

      addLineSpacing(str){
        return str.replaceAll(('\n'), ('<br><br>'));
      }
    },

    mounted: function () {
      this.getTerms();
      window.scrollTo(0,0);
    },

    created () {
    },

    data() {
      return{
        json: data.terms,
        termData: {},
        terms: [],
        descriptions: [],
        termsLeft: [],
        descriptionsLeft: [],
        termsRight: [],
        descriptionsRight: []
      }
    }
  }
</script>

<style lang="css">
</style>